export async function getAllPosts() {
  try {
    const response = await fetch('/blog-content/manifest.json')

    if (!response.ok) {
      throw new Error('Failed to load blog posts')
    }

    const posts = await response.json()
    return posts
  } catch (error) {
    console.error('Error loading blog posts:', error)
    return []
  }
}

export async function getPostBySlug(slug) {
  try {
    // Fetch full metadata from manifest (handles arrays/objects)
    const manifestRes = await fetch('/blog-content/manifest.json')
    if (!manifestRes.ok) throw new Error('Failed to load manifest')
    const manifest = await manifestRes.json()
    const metadata = manifest.find((p) => p.slug === slug)

    if (!metadata) return null

    // Fetch .md file for content body only
    const mdRes = await fetch(`/blog-content/${slug}.md`)
    const text = await mdRes.text()

    if (text.trim().startsWith('<!DOCTYPE html>') || text.includes('<html')) {
      console.warn(`Post not found: ${slug} (received HTML instead of markdown)`)
      return null
    }

    // Strip frontmatter block (everything between first pair of ---)
    const content = text.replace(/^---\r?\n[\s\S]*?\r?\n---\r?\n?/, '').trim()

    return { content, metadata }
  } catch (error) {
    console.error(`Error loading post ${slug}:`, error)
    return null
  }
}
